import Vue from 'vue'
import store from '@/store/index'
import service from '@/services/service'
import VueRouter, { Route, RouteConfig } from 'vue-router'
import { DinamicRouteParams } from '@/interfaces/dynamic-routes-params.interface'
import adminRoutes from './admin/admin'
import publicRoutes from './public/public'
import dinamicRoutes from './dinamic-routes'
import authDecode from 'jwt-decode'

Vue.use(VueRouter)

function mapRoutes () {
    const allRoutes: RouteConfig[] = [
        ...publicRoutes,
        ...adminRoutes
    ]

    const localdinamicRoutes = dinamicRoutes as unknown as DinamicRouteParams[]

    localdinamicRoutes.forEach((route) => {
        if (route.parentName) {
            const parentRoute = allRoutes.find(tempRoute => tempRoute.name === route.parentName)

            if (parentRoute) {
                if (!parentRoute.children) parentRoute.children = []

                parentRoute.children.push(route)
            } else {
                store.commit('reportError', { code: 1000, message: `Couldn't find ${route.parentName} as a Route :(` })
            }
        } else {
            allRoutes.push(route)
        }
    })
    return allRoutes
}

const routes = mapRoutes()

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

function checkAuth (): boolean {
    const localStorageAuth = localStorage.getItem('auth')
    const permissions = localStorage.getItem('permissions')
    if (localStorageAuth) store.commit('updateAuth', JSON.parse(localStorageAuth))
    if (permissions) store.commit('updateUserPermissions', JSON.parse(permissions))
    if (store?.state?.AuthStore?.auth) return true
    return false
}

function checkRoutePermissions (permission: string | string[]) {
    return new Promise(resolve => {
        const userStore = store.state.UsersStore
        const interval = setInterval(() => {
            if (userStore.userPermissions.length !== 0) {
                if (Array.isArray(permission)) {
                    let helper = false
                    permission.forEach((perm: string) => {
                        if (userStore.userPermissions.find((p: { permissionName: string }) => p.permissionName === perm)) helper = true
                    })
                    resolve(helper)
                    clearInterval(interval)
                } else {
                    resolve(!!userStore.userPermissions.find((p: { permissionName: string }) => p.permissionName === permission))
                    clearInterval(interval)
                }
            }
        }, 500)
    })
}

service.interceptors.request.use(async config => {
    const token = store?.getters?.Token?._token || null

    if (token) {
        const auth = authDecode(token)
        auth.exp = new Date(auth.exp * 1000)
        if (auth.exp.getTime() - new Date().getTime() <= 0) { // If token is expired
            // await store.dispatch('saveRouteInLocalStorage')
            //     .then(resp => {
            localStorage.removeItem('goToRouteOnLogin')
            //         if (resp) {
            //             // router.replace({ name: 'WebPage' })
            //         }
            //     })
        }

        config.headers = {
            ...config.headers,
            Authorization: `Bearer ${token}`
        }
    }
    if (!config.data && config.method !== 'delete') config.data = {}
    return config
})

service.interceptors.response.use(
    resp => {
        if (resp.headers.token) {
            const localStorageAuth = localStorage.getItem('auth')
            if (localStorageAuth) {
                const parse = JSON.parse(localStorageAuth)
                parse._token = resp.headers.token
                store.commit('updateAuth', parse)
                localStorage.setItem('auth', JSON.stringify(parse))
            }
        }
        return resp
    },
    async error => {
        if (error?.response?.status === 401) { // Check if it's logged in
            await store.dispatch('saveRouteInLocalStorage')
                .then(resp => {
                    if (resp) {
                        // store.commit('reportError', { code: 1000, message: 'Unauthorized :(' })
                        store.commit('updateAuth', null)
                        localStorage.removeItem('auth')
                        localStorage.removeItem('permissions')
                        localStorage.removeItem('goToRouteOnLogin')
                        router.push({ name: 'WebPage' })
                    }
                })
        }

        if (error?.response?.status === 403) {
            router.push({ name: 'Dashboard' })
        }

        if (error.response.status !== 200) store.commit('reportError', error.response.data) // Report Error
        return error
    }
)

router.beforeEach(async (to: Route, from: Route, next: Function) => {
    if (!to.meta) return next()

    switch (to.meta.auth) {
    case 'public':
        if ((to.name === 'Login' || to.name === 'ForgotPassword') && checkAuth()) {
            const token = store?.getters?.Token?._token || null
            if (token) {
                const auth = authDecode(token)
                auth.exp = new Date(auth.exp * 1000)
                if (auth.exp.getTime() - new Date().getTime() > 0) {
                    return next({ name: 'Dashboard' })
                }
            }
        }
        return next()

    case 'admin':
        if (checkAuth()) {
            if (to.meta.routePermissions) {
                if (await checkRoutePermissions(to.meta.routePermissions)) {
                    return next()
                } else {
                    store.commit('reportError', { code: 1000, message: 'You dont have permission to view this route :(' })
                    return next({ name: 'Dashboard' })
                }
            } else {
                if (to.name === 'Admin') return next({ name: 'Dashboard' })
                return next()
            }
        } else {
            await store.dispatch('saveRouteInLocalStorage')
            return next({ name: 'Login' })
        }

    default:
        return next()
    }
})

export default router
